module.exports = __webpack_public_path__ + "static/media/choithramsSliderOne.bf1b0be6.png";